import { REACT_APP_AUTHENTICATION_URL } from "../constants";
import { fetchBaseUrl, getLocalStorage } from "./helpers";
import { pendingAppSignIn } from "../pages/auth/authenticatorSignIn";

export const buildAuthenticationURL = () => {
  const url = getLocalStorage("URL");
  const redirectUrl = `${fetchBaseUrl()}/tenant/login`;
  const UrlParams = `domainUrl=${encodeURIComponent(url)}&redirectUrl=${encodeURIComponent(redirectUrl)}`;
  // Tells the sign-in console this sign-in is adding a phone to the
  // Authenticator app, so it can say so. Display only — the app's request
  // itself never leaves this origin's sessionStorage.
  return pendingAppSignIn() ? `${UrlParams}&app=authenticator` : UrlParams;
};

export const navigateToAuthentication = () => {
    const authUrl = buildAuthenticationURL();
    window.location.href = `${REACT_APP_AUTHENTICATION_URL}?${authUrl}`;
    return;
};